const SaleOrder = {
  path: "",
  name: "",
  redirect: "/sale-order",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/sale-order",
      redirect: "/sale-order",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Sale Order",
      meta: {
        requiresAuth: true,
        activeUrl: "/sale-order",
        parent: "/sale-order",
        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/saleOrder"),
          meta: {
            requiresAuth: true,
            activeUrl: "/sale-order",
            parent: "/sale-order",

            lv: 2,
          },
        },
        // {
        //   path: "details/:id",
        //   name: "Sale Order Detail",
        //   component: () => import("@/views/pages/saleOrder/detail"),
        //   meta: {
        //     requiresAuth: true,
        //     isChildren: true,
        //     activeUrl: "/sale-order",
        //     parent: "/sale-order",

        //     lv: 3,
        //   },
        // },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default SaleOrder;
